import {  Modal, message } from 'antd';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { DEPOSIT_APPLY_ERRMSG_FOR_VAL18035withNoKYC } from '$ACTIONS/constantsData';
import { ApiPort } from "$ACTIONS/TLCAPI";
import { get } from "$ACTIONS/TlcRequest";

let DepositNameKYCTrait;
export default DepositNameKYCTrait = that => {
    return {
        init: () => {
        },
        handledVAL18031toVAL18035UXofPOSTPaymentApplication: (res, that) => {
            let firstErr = res.errors && res.errors.length && res.errors[0];
            if (!firstErr) { return; }
            let errCode = firstErr?.errorCode;
            if (!errCode) { return; }
            const IS_ERR_VAL18031 = errCode==='VAL18031';
            const IS_ERR_VAL18032 = errCode==='VAL18032';
            const IS_ERR_VAL18033 = errCode==='VAL18033';
            const IS_ERR_VAL18034 = errCode==='VAL18034';
            const IS_ERR_VAL18035 = errCode==='VAL18035';
            const IS_ERR_VAL18035_AND_YesKYC = IS_ERR_VAL18035; // TODO: integrate KYC value when pharse2
            const IS_ERR_VAL18035_AND_NoKYC = IS_ERR_VAL18035; // TODO: integrate KYC value when pharse2
            if (IS_ERR_VAL18031||IS_ERR_VAL18032||IS_ERR_VAL18033||IS_ERR_VAL18034) {
                let step = IS_ERR_VAL18031 ? 1 : (IS_ERR_VAL18032 ? 2 : (IS_ERR_VAL18033 ? 3 : null));
                if (step) {
                    that.DepositNameKYCTrait.popupStepModal(step, {SumSubLink: firstErr.message});
                } else if (IS_ERR_VAL18034) {
                    that.DepositNameKYCTrait.popupInformationModal();
                }
                return true;
            } else if (IS_ERR_VAL18035_AND_NoKYC){
                message.error(DEPOSIT_APPLY_ERRMSG_FOR_VAL18035withNoKYC); // follow backend-doc table
                return true;
            }
        },
        popupInformationModal: () => {
            Modal.confirm({
                className: 'confirm-modal-of-public confirm-modal-of-public-v202409 hide-ant-modal-close-x-modal',
                icon: <div />,
                title: '重新填写存款人姓名', // '验证次数已达上限'
                centered: true,
                okText: '联系在线客服',
                cancelText: '稍后再说',
                content: (<div>
                        <img src={"/cn/img/icons/icon-warn_yellow.png"} className="topicon" />
                        很抱歉，您的存款人姓名不符，请填写已验证的存款账户姓名
                        {/*很抱歉，您的新存款人身份验证次数已达上限，若需要继续验证，请联系在线客服*/}</div>),
                onOk: () => {
                    global.PopUpLiveChat()
                },
            });
        },
        popupStepModal: (step, conf={}) => {
            if (!/^[1-3]$/.test(step)) { return; }
            const SumSubLink = conf && conf.SumSubLink;
            const INDEX = step - 1;
            const ARY_TITLE = ['请完成新存款人身份验证', '新存款人身份审核中', '新存款人身份验证未成功'];
            const ARY_DESC = ['您所填写的存款人姓名与注册姓名不一致，请完成身份验证，以确保新存款账户供本账号使用', '审核中，等待验证结果', '验证不通过，请获取新验证链接，再次验证'];
            const IS_STEP3 = 3==step;
            Modal[IS_STEP3 ? 'confirm' : 'info']({
                className: 'confirm-modal-of-public confirm-modal-of-public-v202409 hide-ant-modal-close-x-modal',
                icon: <div />,
                title: ARY_TITLE[INDEX],
                centered: true,
                okText: IS_STEP3 ? '获取新验证链接' : '我知道了',
                cancelText: IS_STEP3 ? '稍后再说' : undefined,
                content: (<div>
                    <img src={"/cn/img/icons/icon-warn_yellow.png"} className="topicon" />
                    {ARY_DESC[INDEX]}
                    <div style={{borderRadius:8, padding:16, marginTop:16, background: '#F5F5F5'}}>
                        <ul className={"process-vline"+(step ? ' step'+step : '')}>
                            <li>{1==step ? <div>链接
                                <CopyToClipboard text={SumSubLink} onCopy={()=>global.showColorResultModal('已复制', true)}>
                                    <img style={{ marginLeft: '0.4rem', cursor: 'pointer' }} src={`/cn/img/icons/Copys.svg`} />
                                </CopyToClipboard>
                                </div> : null}复制验证链接，并传给新存款人
                            </li>
                            <li>{step!=2 ? '处理中' : '审核中，等待验证结果'}</li>
                            <li>{IS_STEP3 ? '验证不通过' : '验证结果'}</li>
                        </ul>
                    </div>
                </div>),
                onOk: IS_STEP3 ? () => {
                    const name = that.props.form.getFieldValue("accountHolderName"); // or that.depositorName
                    get(ApiPort.GetDepositorNameVerificationLink + '&depositorName=' + name + '&isReset=true').then(res => {
                        if (res && res.isSuccess && res.result?.verificationLink) {
                            that.DepositNameKYCTrait.popupStepModal(1, {SumSubLink: res.result.verificationLink})
                        } else {
                            message.error('系统错误，请稍后再试。')
                        }
                    }).catch(error => {
                        //...
                    });
                } : undefined,
            });
        }
    }
}
